import type { CityConfig } from "../city-template/types";

export const gastoniaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Gastonia",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "gastonia",
  route: "/cities/gastonia",
  title: "Emergency Passport Gastonia, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Gastonia, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Gaston County and the west Charlotte metro area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Gastonia, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Gastonia and west Charlotte metro area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Gastonia%20North%20Carolina%20cityscape%20at%20golden%20hour%20with%20charming%20downtown%20historic%20district%2C%20renovated%20brick%20buildings%2C%20modern%20civic%20center%20visible%20in%20the%20background%2C%20lush%20green%20trees%20and%20rolling%20hills%20of%20the%20Piedmont%20region%2C%20warm%20sunset%20light%20over%20Gaston%20County%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20suburban%20southern%20charm%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=gastonia-hero-nc-001&orientation=landscape",
  heroImageAlt: "Gastonia North Carolina downtown historic district at golden hour with charming brick buildings and Piedmont hills",
  geoPosition: "35.2621;-81.1873",
  geoPlacename: "Gastonia, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 230 miles from Gastonia via I-85",
  },
  nearbyCitiesZips: [
    { name: "Gastonia", zips: "28052, 28053, 28054, 28056" },
    { name: "Belmont", zips: "28012" },
    { name: "Mount Holly", zips: "28120" },
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Kings Mountain", zips: "28086" },
    { name: "Lincolnton", zips: "28092, 28093" },
    { name: "Cherryville", zips: "28021" },
    { name: "Shelby", zips: "28150, 28151, 28152" },
    { name: "Cramerton", zips: "28032" },
    { name: "Lowell", zips: "28098" },
    { name: "Dallas", zips: "28034" },
    { name: "Stanley", zips: "28164" },
    { name: "McAdenville", zips: "28101" },
    { name: "Bessemer City", zips: "28016" },
    { name: "Ranlo", zips: "28054" },
    { name: "Spencer Mountain", zips: "28054" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Gaston County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "West Charlotte Metro Hub", desc: "Serving Gastonia, Belmont, Mount Holly, and the entire Gaston County area" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Fast passport renewal in Concord, NC", route: "/cities/concord-nc" },
    { name: "Emergency passport help in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Urgent passport services in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Same-day passport help in Winston-Salem, NC", route: "/cities/winston-salem" },
    { name: "Passport courier services in Durham, NC", route: "/cities/durham" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Gastonia remotely via secure courier. We do not have a walk-in office in Gastonia — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Gaston County and the west Charlotte metro area travelers.",
  fpcOfficeAddress: "301 S McDowell St, Charlotte, North Carolina 28204",
  fpcOfficeDistance: "Serving all of Gaston County and the west Charlotte metropolitan region",
  serviceAreaIntro: "From downtown Gastonia's historic district to the suburbs of Belmont and Mount Holly, from the Cramerton riverfront to the rolling hills of Kings Mountain and Lincolnton — Fast Passport Center serves the entire Gastonia region. We regularly help travelers from Charlotte, Shelby, Cherryville, and the west Charlotte metro area get their passports fast.",
  nearbyCitiesIntro: "We serve all Gastonia neighborhoods and the surrounding west Charlotte metro area including Belmont, Mount Holly, Charlotte, Kings Mountain, Lincolnton, Cherryville, Shelby, Cramerton, Lowell, Dallas, Stanley, McAdenville, Bessemer City, and Ranlo. If you are anywhere in Gaston County or the western Charlotte metropolitan area, we have you covered.",
  howItWorksIntro: "Most Gastonia travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Gastonia travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Gastonia and Gaston County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Gastonia? Here are the most common ones we hear from Gaston County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Gastonia international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Kimberly R.",
      location: "Gastonia, NC",
      rating: 5,
      text: "My passport expired the day before my cruise to the Bahamas. Fast Passport Center had my renewal ready in 32 hours. Never had to leave Gaston County. Incredible service.",
      service: "Passport Renewal",
    },
    {
      name: "Brian S.",
      location: "Belmont, NC",
      rating: 5,
      text: "Emergency passport for a family emergency in the UK. Got it in 38 hours. The team kept me updated every step. I didn't have to drive to Atlanta — amazing.",
      service: "Emergency Passport",
    },
    {
      name: "Maria L.",
      location: "Mount Holly, NC",
      rating: 5,
      text: "First passport for my 12-year-old before our mission trip. Fast Passport Center walked us through every document and had her passport ready in 5 days. Completely stress-free.",
      service: "Child Passport",
    },
    {
      name: "James T.",
      location: "Kings Mountain, NC",
      rating: 5,
      text: "Lost my passport 4 days before a business trip to Toronto. Fast Passport Center had a replacement in my hands in 30 hours. Lifesavers for the west Charlotte metro area.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "gastonia-1",
      name: "Gastonia Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 W Main Ave",
      city: "Gastonia",
      state: "NC",
      zip: "28052",
      phone: "(704) 866-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Gastonia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Gastonia facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "gastonia-2",
      name: "Belmont Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 N Main St",
      city: "Belmont",
      state: "NC",
      zip: "28012",
      phone: "(704) 825-3171",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles east of Gastonia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Belmont and Cramerton residents. Less crowded than Gastonia. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "gastonia-3",
      name: "Mount Holly Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "212 S Main St",
      city: "Mount Holly",
      state: "NC",
      zip: "28120",
      phone: "(704) 827-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles northeast of Gastonia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Mount Holly and northwest Gaston County. Ample parking. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "gastonia-4",
      name: "Kings Mountain Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "106 S Battleground Ave",
      city: "Kings Mountain",
      state: "NC",
      zip: "28086",
      phone: "(704) 739-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles west of Gastonia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves western Gaston County and Cleveland County border area. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "gastonia-5",
      name: "Gaston County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "325 N Marietta St",
      city: "Gastonia",
      state: "NC",
      zip: "28052",
      phone: "(704) 852-3100",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Gastonia, Courthouse",
      website: "https://www.gastongov.com/",
      websiteLabel: "Gaston County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "gastonia-6",
      name: "Charlotte Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Tryon St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 344-4183",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles east of Gastonia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Charlotte metro. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Gastonia photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Gaston County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Gastonia applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Gaston County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Gastonia travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Gastonia." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Gastonia address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Gastonia before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Gastonia for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Gastonia?", a: "Fast Passport Center offers fast passport renewal in Gastonia in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Gastonia?", a: "The nearest regional passport agency to Gastonia is the Atlanta Passport Agency, approximately 230 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Gastonia without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Gastonia?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 4 hours from Gastonia — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Gaston County residents." },
    { q: "Do you serve the entire west Charlotte metro area?", a: "Absolutely. Fast Passport Center serves the entire west Charlotte metropolitan area including Gastonia, Belmont, Mount Holly, Charlotte, Kings Mountain, Lincolnton, Cherryville, Shelby, Cramerton, Lowell, Dallas, Stanley, McAdenville, Bessemer City, and Ranlo. Our courier service works seamlessly from any address in Gaston County and surrounding areas." },
    { q: "Can I expedite a child passport in Gastonia?", a: "Yes. Fast Passport Center expedites child passports in Gastonia for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Gaston County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Gastonia with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Gastonia", address: "3690 E Franklin Blvd, Gastonia, NC 28056", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Gastonia", address: "2155 W Franklin Blvd, Gastonia, NC 28052", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Gastonia", address: "3000 E Franklin Blvd, Gastonia, NC 28056", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "FedEx Office — Charlotte", address: "550 S Tryon St, Charlotte, NC 28202", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
    { name: "CVS Pharmacy — Belmont", address: "614 Park St, Belmont, NC 28012", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Mount Holly", address: "111 N Main St, Mount Holly, NC 28120", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Kings Mountain", address: "104 E Gold St, Kings Mountain, NC 28086", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart — Shelby", address: "200 E Dixon Blvd, Shelby, NC 28152", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Gastonia",
      address: "245 E Garrison Blvd, Gastonia, NC 28054",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Charlotte South",
      address: "8520 E Independence Blvd, Charlotte, NC 28227",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Belmont",
      address: "6500 Wilkinson Blvd, Belmont, NC 28012",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Belmont and Cramerton area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Shelby",
      address: "200 E Dixon Blvd, Shelby, NC 28152",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Cleveland County and western Gaston area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "25 miles east of Gastonia",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international airport for the Charlotte metro area. American Airlines hub with direct flights to Europe, Mexico, the Caribbean, and major domestic destinations.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "80 miles northeast of Gastonia",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for North Carolina residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "160 miles east of Gastonia",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Gaston County Register of Deeds',
      description: 'Marriage licenses and records for Gaston County. Apply in person or request certified copies.',
      url: 'https://www.gastongov.com/departments/register-of-deeds',
    },
    {
      label: 'Gaston County Clerk of Superior Court',
      description: 'Divorce records and decrees for Gaston County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/gaston-county/gaston-county-clerk-of-superior-court',
    },
  ],
};